import { gql } from "@apollo/client";

export const GET_MESSAGES = gql`
  query getMessages($professionistId: Int!, $patientId: Int!) {
    messages(
      professionist_id: $professionistId
      patient_id: $patientId
    ) {
      id
      from
      content
      created_at
      is_seen
    }
  }
`;

export const ADD_MESSAGE = gql`
  mutation addMessage($from: Int!, $professionistId: Int!, $patientId: Int!, $content: String!) {
    addMessage(
      professionist_id: $professionistId
      patient_id: $patientId
      from: $from
      content: $content
    ) {
      id
      from
      content
      created_at
      is_seen
    }
  }
`;
